import { render } from "./solicitudes-create.vue?vue&type=template&id=138c4cd2"
import script from "./solicitudes-create.vue?vue&type=script&lang=js"
export * from "./solicitudes-create.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__